// extracted by mini-css-extract-plugin
export default {"base":"Tasks_base__RVi3g","cell":"Tasks_cell__kbbEV","dropDownSelection":"Tasks_dropDownSelection__lA-nE"};